import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import lifeInsuranceService from "../../api/lifeinsuranceService";
import apiClient from "../../api/config";
import { LIFE_INSURANCE_ENDPOINTS } from "../../api/endpoints";

export const fetchLifeInsurance = createAsyncThunk(
  "lifeInsurance/fetch",
  async (inputs, { rejectWithValue }) => {
    try {
      const response = await lifeInsuranceService.lifeInsurance(inputs);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
export const calculatorAnalytics = createAsyncThunk(
  "lifeInsurance/calculatorAnalytics",
  async (inputs, { rejectWithValue }) => {
    try {
      const response = await lifeInsuranceService.calculatorAnalytics(inputs);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
export const downloadPDFThunk = createAsyncThunk(
  "pdf/download",
  async (data, { rejectWithValue }) => {
    try {
      const response = await apiClient.post(
        LIFE_INSURANCE_ENDPOINTS.DownloadlifeInsurancePDF,
        data,
        { responseType: "blob" },
      );

      // Trigger download inside thunk
      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `Life_Insurance_Quote.pdf`;
      link.click();
      window.URL.revokeObjectURL(url);

      return { success: true };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

const initialState = {
  lifeInsuranceItems: [],
  calculatorAnalyticsItems: [],
  // lifeInsurancePDF: null,
  quote: null,
  isLoading: false,
  isError: false,
  errorMessage: "",
  hasInitialized: false,
};

const lifeInsuranceSlice = createSlice({
  name: "lifeInsurance",
  initialState,
  reducers: {
    clearLifeInsurance: (state) => {
      state.lifeInsuranceItems = [];
      state.hasInitialized = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLifeInsurance.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
      })
      .addCase(fetchLifeInsurance.fulfilled, (state, action) => {
        state.isLoading = false;
        state.hasInitialized = true;
        state.isError = false;

        state.quote = action.payload?.data || null;
      })
      .addCase(fetchLifeInsurance.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.hasInitialized = true;
        state.errorMessage =
          action.payload || "Failed to load life insurance data.";
        state.lifeInsuranceItems = [];
      })
      .addCase(calculatorAnalytics.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
      })
      .addCase(calculatorAnalytics.fulfilled, (state, action) => {
        state.isLoading = false;
        state.hasInitialized = true;
        state.isError = false;
        state.calculatorAnalyticsItems = action.payload?.data || [];

        // state.quote = action.payload?.data || null;
      })
      .addCase(calculatorAnalytics.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.hasInitialized = true;
        state.errorMessage =
          action.payload || "Failed to load life insurance data.";
        state.calculatorAnalyticsItems = [];
      });
    // .addCase(fetchLifeInsurancePDF.pending, (state) => {
    //   state.isLoading = true;
    //   state.isError = false;
    // })
    // .addCase(fetchLifeInsurancePDF.fulfilled, (state, action) => {
    //   state.isLoading = false;
    //   state.hasInitialized = true;
    //   state.isError = false;

    //   state.lifeInsurancePDF = action.payload?.data || null;

    // })
    // .addCase(fetchLifeInsurancePDF.rejected, (state, action) => {
    //   state.isLoading = false;
    //   state.isError = true;
    //   state.hasInitialized = true;
    //   state.errorMessage =
    //     action.payload || "Failed to download life insurance pdf.";
    // });
  },
});

export const { clearLifeInsurance } = lifeInsuranceSlice.actions;
export default lifeInsuranceSlice.reducer;
